import Icon from './Icon.jsx'

const ICONS = {
  'Shower Screens': 'glass',
  Hardware: 'tag',
  'Glass Panels': 'glass',
  '10mm Frameless Glass Panels': 'glass',
  'Tools & Accessories': 'box',
}

// Branded placeholder for products without a photo yet.
export default function Placeholder({ category = '', label = 'Photo coming soon' }) {
  return (
    <div className="placeholder" role="img" aria-label={label}>
      <Icon name={ICONS[category] || 'glass'} size={44} stroke={1.4} />
      <span>{label}</span>
    </div>
  )
}
